<template>

    <crud-container :name="name">

        <crud-nav>
            <crud-nav-header title="Companies" searchable="true"></crud-nav-header>

            <div class="grouping-key-container">
                <a v-for="(contactList,groupingKey) in items" @click.prevent="scrollContainerTo(groupingKey)" href="#">{{
                    groupingKey }}</a>
            </div>

            <crud-nav-scroll>
                <div class="grouped-item-listings" v-for="(companyList,groupingKey) in items">
                    <h2>{{ groupingKey }}</h2>
                    <span class="hide-me-please" :id="'item-list-group-heading-'+groupingKey"></span>
                    <ul v-if="companyList">
                        <li class="items-list-item" :class="{active: isCurrentItem(company) }"
                            v-for="company in companyList">
                            <div class="name">
                                <a href="#" @click.prevent="getAndViewItemById(company.id)">{{ company.name }}</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </crud-nav-scroll>
        </crud-nav>

        <crud-main>
            <crud-new>
                <crud-main-header title="Create New Company" can-go-back-to-nav="true"></crud-main-header>

                <companies-create></companies-create>

            </crud-new>
            <crud-edit>
                <crud-main-header :title="'Editing: '+current_item.name" can-edit="true" can-go-back="true" :item="current_item"></crud-main-header>
                <crud-errors :errors="errors"></crud-errors>

                <dl>
                    <dt>Name</dt>
                    <dd><input type="text" v-model="current_item.name"/></dd>
                    <dt>Email</dt>
                    <dd><input type="email" v-model="current_item.email"/></dd>
                    <dt>Website</dt>
                    <dd><input type="text" v-model="current_item.website"/></dd>
                </dl>

                <div class="action-button-group">
                    <a href="#" class="action-button action-button-dismiss" @click.prevent="backToItem()">
                        <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
                    </a>
                    <a href="#" class="action-button action-button-success" @click.prevent="saveItem()">
                        <i class="fa fa-check" aria-hidden="true"></i> Update Company
                    </a>
                </div>

            </crud-edit>
            <crud-view>
                <crud-main-header :title="current_item.name" can-edit="true" can-go-back-to-nav="true" :item="current_item"></crud-main-header>

                <dl>
                    <dt>Name</dt>
                    <dd>{{ current_item.name }}</dd>
                    <dt>Email</dt>
                    <dd><a :href="'mailto:'+current_item.email">{{ current_item.email }}</a></dd>
                    <dt>Website</dt>
                    <dd><a :href="current_item.website">{{ current_item.website}}</a></dd>
                </dl>
            </crud-view>
        </crud-main>

    </crud-container>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                name:'companies',
                items: [],
                current_item:{},
                new_item:{},
                search_query: null,
                errors:null
            }
        },
        watch: {},
        computed: {
            has_query(){
                return this.search_query != '' && !_.isNull(this.search_query);
            }
        },
        methods: {
            isCurrentItem: function (item) {
                if (!("id" in this.current_item)) {
                    return false;
                }

                return item.id === this.current_item.id;
            },
            scrollContainerTo: function (key) {
                var $relevantElement = $("#item-list-group-heading-" + key);
                console.log('Scrolling To: '+key,$relevantElement.offset().top);

                $('.crud-scroller').first().scrollTop(0);

                $('.crud-scroller').first().animate({
                    scrollTop: $relevantElement.offset().top - 180
                }, 500);
            },
            saveItem: function () {
                var that = this;
                var editingItem = $.extend({}, this.current_item);

                axios.put(appUrls.companies.update.replace('REPLACEME', editingItem.id), editingItem)
                    .then(response => {
                        that.viewItem(response.data.data);
                        that.resetErrors();

                    }).catch(function (error) {
                    if (error.response.status === 422) {
                        that.errors = error.response.data.errors;
                    }
                });
            },
            deleteItem(itemToDelete) {
                var that = this;
                var title = 'Are you sure you want to delete "' + itemToDelete.name + '"?';
                var description = 'Deleting this company is irreversible. Are you sure you want to delete it?';

                eventBus.$emit('delete-modal-open', title, description, function () {
                    that.activeItem = null;

                    let index = that.items.indexOf(itemToDelete);
                    that.items.splice(index, 1);

                    eventBus.$emit('crud-show-new-'+that.name);
                    axios.delete(appUrls.companies.destroy.replace('REPLACEME', itemToDelete.id));
                    eventBus.$emit('crud-back-to-nav-'+that.name);
                });
            },
            resetErrors(){
                this.errors = null;
            },
            getItems(){
                var that = this;
                var url = appUrls.companies.index;
                var params = {};

                if (this.has_query) {
                    params.query = this.search_query;
                }

                params.group_by_letter = true

                axios.get(url, {params: params})
                    .then(response => {
                        that.items = response.data.data;
                        var hasCompanyGetVariable = location.search.indexOf('company=') >= 0;
                        if (hasCompanyGetVariable) {
                            var companyIdFromVariable = getParameterByName('company');
                            if (fieldWithValueExistsInCollection(that.items, 'id', companyIdFromVariable)) {
                                that.viewItem(getItemByFieldAndValue(that.items, 'id', companyIdFromVariable));
                            } else {
                                that.getAndViewItemById(companyIdFromVariable);
                            }
                        }
                    });
            },
            getAndViewItemById(id) {
                var that = this;
                var url = appUrls.companies.show.replace('REPLACEME', id);

                axios.get(url)
                    .then(response => {
                        that.viewItem(response.data.data);
                    });
            },
            viewItem(item){
                window.eventBus.$emit('crud-view-item-'+this.name,item);
            },
            backToNav: function(){
                window.eventBus.$emit('crud-back-to-nav-'+this.name);
            },
            backToItem: function(){
                window.eventBus.$emit('crud-back-'+this.name);
            }
        },
        mounted() {
            var that = this;
            this.getItems();
            window.eventBus.$on('crud-errors-dismissed', function () {
                that.errors = null;
            });
            window.eventBus.$on('crud-search-query-changed-'+this.name, _.debounce(function (query) {
                that.search_query = query;
                that.getItems();
            }, 250));

            window.eventBus.$on('item-created-'+this.name,function(company){
                that.getItems();
                that.viewItem(company);
            });

            window.eventBus.$on('crud-search-hidden-'+this.name, function (query) {
                that.search_query = null;
                that.getItems();
            });

            window.eventBus.$on('crud-edit-item-'+this.name, function (item) {
                this.new_item = {};
                this.current_item = item;
                that.resetErrors();
            });

            window.eventBus.$on('crud-delete-item-'+this.name, function (item) {
                that.deleteItem(item);
                that.resetErrors();
            });

            window.eventBus.$on('crud-view-item-'+this.name, function (item) {
                that.new_item = {};
                that.current_item = item;
                that.resetErrors();
            });

            window.eventBus.$on('crud-back-'+this.name, function (item) {
                that.current_item = item;
                that.viewItem(item);
                that.resetErrors();
            });

            window.eventBus.$on('crud-back-to-nav-'+this.name, function () {
                that.current_item = {};
                that.new_item = {};
                that.resetErrors();
            });
        }
    }
</script>

<style lang="scss" scoped>

</style>
